<template>
  <div>
    <div class="mainWrap">
      <div class="head_car" v-show="(order_type == '普通卡运' && xuanze == true) || (order_type == '普通卡运' && width < 800)">
        <span class="server">{{ create_service }} {{
          name
        }} </span>
        <div class="car_info">
          <div class="info_top">
            <div class="top_left"><span>卡运: {{ order_number }} </span><img src="../../assets/img/fuzhi.png" alt=""
                @click="copy">
            </div>
            <div class="top_right">{{ order_type }}</div>
          </div>
          <div class="info_bottom">
            <div class="bottom_left">
              <p class='plan_time' v-if="trackInfo.plan_day">预计时效{{ trackInfo.plan_day }}天</p>
              <p class='state' :style="{ marginTop: trackInfo.plan_day ? '' : '15px' }">{{ trackInfo.state }}</p>
              <p class='time'>{{ trackInfo.state_time }}</p>
            </div>
            <div class="bottom_right">
              <div class='di1'>
                <div class="three">{{ trackInfo.depart_port_three_no }}</div>
                <div class="address">{{ trackInfo.depart_port_name_cn }}</div>

              </div>
              <img src="../../assets/img/gang.png" alt="" class='gang'>
              <div class='di2'>
                <div class="three">{{ trackInfo.arrive_port_three_no }}</div>
                <div class="address">{{ trackInfo.arrive_port_name_cn }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="scroll" :class="show == true ? 'scroll' : 'scroll2'" @click="dian"
        v-show="(order_type == '普通卡运' && xuanze == true) || (order_type == '普通卡运' && width < 800)">
        <div class="scroll_head">
          <div class="details">运单动态详情</div>
          <div class="just_flex">
            <div class="push">订阅推送</div>
            <div @click.stop="switchChange">
              <el-switch v-model="value" active-color="#13ce66" inactive-color="#DADADA" class="switch"
                @click="switchChange">
              </el-switch>
            </div>
          </div>

        </div>
        <div class="step_content" style="width: 200px;">

          <el-steps direction="vertical" :active="1" space="60">
            <el-step :title="i.description" v-for="(i, index) in trackInfo.process_list" :key="index">
              <i slot="icon">
                <img :src='index == 0 ? `${url}wc.png` : `${url}wc1.png`' mode="" class="step_image"
                  v-if="i.description == '完成'">
                <img :src='index == 0 ? `${url}th.png` : `${url}th1.png`' mode="" class="step_image"
                  v-if="i.description == '提货'">
                <img :src='index == 0 ? `${url}qs.png` : `${url}qs1.png`' mode="" class="step_image"
                  v-if="i.description == '卡运签收'">
                <img :src='index == 0 ? `${url}ls.png` : `${url}ls1.png`' mode="" class="step_image"
                  v-if="i.description == '卡运揽收'">
                <img :src='index == 0 ? `${url}rk.png` : `${url}rk1.png`' mode="" class="step_image"
                  v-if="i.description == '货物入库'">
                <img :src='index == 0 ? `${url}aj.png` : `${url}aj1.png`' mode="" class="step_image"
                  v-if="i.description == '货物安检'">
                <img :src='index == 0 ? `${url}sh.png` : `${url}sh1.png`' mode="" class="step_image"
                  v-if="i.description == '仓库收货' || i.description == '尾程入仓'">

                <img :src='index == 0 ? `${url}fh.png` : `${url}fh1.png`' mode="" class="step_image"
                  v-if="i.description == '客户发货'">
                <img :src='index == 0 ? `${url}xd.png` : `${url}xd1.png`' mode="" class="step_image"
                  v-if="i.description == '已下单'">
                <img :src='index == 0 ? `${url}fc.png` : `${url}fc1.png`' mode="" class="step_image"
                  v-if="i.description == '发出'">
                <img :src='index == 0 ? `${url}dd.png` : `${url}dd1.png`' mode="" class="step_image"
                  v-if="i.description == '到达'">
                <img :src='index == 0 ? `${url}qx.png` : `${url}qx1.png`' mode="" class="step_image"
                  v-if="i.description == '取消'">
              </i>
              <div slot="description" v-for="(j, indexs) in i.data" :key="indexs" class="dot">
                <p>{{ j.remark }}</p>
                <span>{{ j.operate_time }}</span> <span
                  v-show="(i.data.length > 2 && indexs != 0) || (i.data.length == 2 && indexs == 1)" class="fenpi">★
                  分批</span>
              </div>
            </el-step>

          </el-steps>

        </div>
      </div>

      <div class="header" v-show="xuanze == false && width > 800">
        <div class="leftWrap">
          <img src="../../assets/img/map/logo_white.png" alt="" class="logo" />
          <span class="orderNum">{{ trackInfo.order_no }}</span>
          <span class="orderStatus">{{ trackInfo.state }}</span>
        </div>
        <div class="rightWrap">
          <div class="statusItem" :class="{ active: dataindex >= 0 }">
            <div class="circle"></div>
            <span class="title">已订舱 </span>
            <span class="info">{{ trackInfo.state_dc_time }}</span>
          </div>
          <div class="statusItem" :class="{ active: dataindex >= 1 }">
            <div class="circle"></div>
            <span class="title">已发出 </span>
            <span class="info">{{ trackInfo.state_fc_time }}</span>
          </div>
          <div class="statusItem" :class="{ active: dataindex >= 2 }">
            <div class="circle"></div>
            <span class="title">已收货 </span>
            <span class="info">{{ trackInfo.state_sh_time }}</span>
          </div>
          <div class="statusItem" :class="{ active: dataindex >= 3 }">
            <div class="circle"></div>
            <span class="title">已安检 </span>
            <span class="info">{{ trackInfo.state_aj_time }}</span>
          </div>
          <div class="statusItem" :class="{ active: dataindex >= 4 }">
            <div class="circle"></div>
            <span class="title">已入库 </span>
            <span class="info">{{ trackInfo.state_rk_time }}</span>
          </div>
          <div class="statusItem" :class="{ active: dataindex >= 5 }">
            <div class="circle"></div>
            <span class="title">已组板 </span>
            <span class="info">{{ trackInfo.state_zb_time }}</span>
          </div>
          <div class="statusItem" :class="{ active: dataindex >= 6 }">
            <div class="circle"></div>
            <span class="title">已起飞 </span>
            <span class="info">{{ trackInfo.state_qf_time }}</span>
          </div>
          <div class="statusItem" :class="{ active: dataindex >= 7 }">
            <div class="circle"></div>
            <span class="title">已落地 </span>
            <span class="info">{{ trackInfo.state_ld_time }}</span>
          </div>
          <div class="statusItem" :class="{ active: dataindex >= 8 }">
            <div class="circle"></div>
            <span class="title">已提货 </span>
            <span class="info">{{ trackInfo.state_th_time }}</span>
          </div>
        </div>
      </div>
      <div class="mainContent">
        <Draw_Map id="map" :collRes="trackInfo.coll_res" :giveRes="trackInfo.give_res" :trackInfo="trackInfo"
          v-if="trackInfo" @click.native="showList" />
        <div :class="`airDetail ${!trackInfo.transfer_port_three_no && 'small'}`" v-show="xuanze == false && width > 800">
          <div :class="`trackHeader ${noHeader && 'noHeader'}`">
            <div class="trackItem">
              <!-- 如果有起飞时间或者是提单状态为已起飞和已落地  那个箭头变绿 class类-->
              <!-- 横线上的内容为data-no -->
              <span class="title" :class="{
                titlest: dataindex >= 6 || trackInfo.actual_depart_time,
              }" :data-no="trackInfo.voyage_name">{{ trackInfo.depart_port_three_no }}</span>
              <div class="timeDetail">
                <!-- 如果有起飞时间或者是有预计起飞时间显示 -->
                <span>{{
                  trackInfo.actual_depart_time || plan_departTime
                }}</span>
                <!-- 这里是卡车信息 -->
                <span :class="`no ${trackInfo.coll_res &&
                    trackInfo.coll_res.c_truck_name &&
                    'top'
                    }`">{{
      trackInfo.coll_res && trackInfo.coll_res.c_truck_name
    }}</span>
              </div>
            </div>
            <!-- 中转站暂时不要了，屏蔽掉 -->
            <!-- <div class="trackItem" v-if="trackInfo.transfer_port_three_no">
              如果有实际落地时间或者是提单状态为已落地  箭头变绿
              <span class="title" :class="{ titlest:dataindex>=7}"
                :data-no="trackInfo.transfer_voyage_name">{{trackInfo.transfer_port_three_no}}</span>
            </div> -->
            <!-- <div class="transform_time">中转2次</div> -->
            <div class="trackItem">
              <div class="just_flex">
                <span class="title fortext" :class="{ titlest: trackInfo.actual_arrive_time }" :data-name="trackInfo.stop_over_num > 0
                    ? '中转' + trackInfo.stop_over_num + '次'
                    : ''
                  ">{{ trackInfo.arrive_port_three_no }}</span>
                <span class="stateTag" :class="[{flying: trackInfo.voyage_state=='飞行中'},{finish: trackInfo.voyage_state=='已落地'}]">
                  {{ trackInfo.voyage_state }}</span>
              </div>
              <div class="timeDetail">
                <!-- 落地时间和预计落地时间 -->
                <span>{{ trackInfo.actual_arrive_time ? trackInfo.actual_arrive_time : trackInfo.state_ld_time ?
                  trackInfo.state_ld_time : plan_arriveTime
                }}</span>
                <!-- 卡车相关信息 -->
                <span :class="`no ${trackInfo.give_res &&
                    trackInfo.give_res.g_truck_name &&
                    'bottom'
                    }`">{{
      trackInfo.give_res && trackInfo.give_res.g_truck_name
    }}</span>
              </div>
            </div>
          </div>
          <div class="noticeTime" v-if="trackInfo.notice_pick_time">
            <img src="../../assets/img/map/laba.png" alt="" class="laba"/>
            <span>提货通知时间：{{ trackInfo.notice_pick_time }}</span>
          </div>

          <div class="progressWrap">
            <p class="title">
              <span>{{ trackInfo.order_no }}&nbsp;</span>[{{
                trackInfo.order_volume
              }}M³<sup></sup> {{ trackInfo.order_weight }}KG
              {{ trackInfo.order_number }}箱]
            </p>
            <div class="progress">
              <span>进度：</span>
              <div>
                <div class="fill" :data-rate="`${trackInfo.progress_bar || 0}%`"
                  :style="`width:${trackInfo.progress_bar || 0}%;`"></div>
              </div>
            </div>
          </div>

          <div class="routeWrap">
            <div class="routeItem" v-if="hasStartList">
              <div class="routeItemHeader">
                <div class="iconWrap">
                  <div><img src="../../assets/img/map/car.png" alt="" /></div>
                </div>
                <label>接货揽收：</label>
                <span>{{ trackInfo.coll_res.coll_address }}</span>
              </div>
              <div :class="{
                routeDetails:
                  dataindex <= 0 && trackInfo.coll_res.coll_time == '',
                routeDetail:
                  dataindex >= 1 || trackInfo.coll_res.coll_time !== '',
              }">
                <div class="leftWrap">
                  <span class="routeNo">{{
                    trackInfo.coll_res.c_truck_name
                  }}</span>
                  <span class="routeTime"
                    v-if="trackInfo.state_fc_time == '' && trackInfo.coll_res.coll_time == '' && dataindex < 1">{{
                      trackInfo.coll_res.expect_coll_time
                    }}</span>
                </div>
                <div class="rightWrap">
                  <div class="timeLine">
                    <div class="tlItem active">
                      <span v-if="dataindex <= 0 && trackInfo.coll_res.coll_time == ''
                          ">
                        待揽收
                      </span>
                      <span v-if="dataindex >= 1 || trackInfo.coll_res.coll_time !== ''
                        ">
                        已揽收
                      </span>
                    </div>
                    <div class="tlItem" :class="{
                      active: dataindex >= 1 || trackInfo.coll_res.coll_time,
                    }">
                      <span>揽收时间：{{ trackInfo.coll_res.coll_time }}</span>
                    </div>
                    <!-- 如果有发出时间,线条圆点变色 只显示多辆揽收车辆的第一条信息 -->
                    <div class="tlItem" :class="{
                      active: dataindex >= 1 || trackInfo.coll_res.coll_time,
                    }">
                      <div v-for="(item, index) in trackInfo.coll_res.coll_data" :key="index">
                        <span>运输卡车：{{ item.coll_truck_name }}</span>
                        <span class="text-number">[{{ item.volume }}M³<sup></sup> {{ item.weight }}KG
                          {{ item.number }}箱]</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="routeItem" v-if="trackInfo.depart_port_name_cn">
              <div class="routeItemHeader">
                <div class="iconWrap">
                  <!-- 如果 接收 安检 入库 组板 离开 时间都为空，显示灰色图标 -->
                  <div v-if="takeoff_icon == 1">
                    <img src="../../assets/img/map/huifj.png" alt="" />
                  </div>
                  <!-- 如果 接收 安检 入库 组板 离开 时间任意不为空，显示绿色图标 -->
                  <div v-if="takeoff_icon == 0">
                    <img src="../../assets/img/map/icon.png" alt="" />
                  </div>
                </div>
                <label>起运机场：</label>
                <span>{{ trackInfo.depart_port_name_cn }}</span>
              </div>
              <!-- 如果起飞时间为空 且状态低于已起飞 -->
              <div v-bind:class="[tackoff_wire ? 'routeDetails' : 'routeDetail']">
                <div class="leftWrap">
                  <span class="routeNo">{{ trackInfo.voyage_name }}</span>
                  <span class="routeTime zhanwei">{{
                    trackInfo.actual_depart_time == "" ? plan_departTime : ""
                  }}</span>

                  <!-- <el-tooltip
                    class="item"
                    effect="dark"
                    content="Top Left 提示文字"
                    placement="top"
                  > -->
                  <div class="fenpi" v-if="trackInfo.is_batches">分批拉货</div>
                  <!-- </el-tooltip> -->
                </div>
                <div class="rightWrap">
                  <div class="timeLine">
                    <div class="tlItem" :class="{ active: dataindex >= 2 }">
                      <span>接收时间：{{ trackInfo.state_sh_time }}</span>
                    </div>
                    <div class="tlItem" :class="{ active: dataindex >= 3 }">
                      <span>安检时间：{{ trackInfo.state_aj_time }}</span>
                    </div>
                    <div class="tlItem" :class="{ active: dataindex >= 4 }">
                      <span>入库时间：{{ trackInfo.state_rk_time }}</span>
                    </div>
                    <div class="tlItem" :class="{ active: dataindex >= 5 }">
                      <span>组板时间：{{
                        trackInfo.now_board_time || trackInfo.state_zb_time
                      }}</span>
                    </div>
                    <div class="tlItem" :class="{ active: dataindex >= 6 }">
                      <span>离开时间：{{ trackInfo.actual_depart_time }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 中转机场修改这里增加v-for -->

            <div class="routeItem" v-for="(i, index) in transform_list" :key="index">
              <div class="routeItemHeader">
                <div class="iconWrap">
                  <div v-if="!trackInfo.actual_depart_time">
                    <img src="../../assets/img/zhongzhuan2.png" alt="" />
                  </div>
                  <div v-else>
                    <img src="../../assets/img/zhongzhuan.png" alt="" />
                  </div>
                </div>
                <label>经停机场：</label>
                <span>{{ i.arrive_port_name_cn }}</span>
              </div>
              <div v-bind:class="{
                routeDetail: dataindex >= 6,
                routeDetails: dataindex < 6,
              }">
                <div class="leftWrap">
                  <span class="routeNo">{{
                    trackInfo.transfer_voyage_name || trackInfo.voyage_name
                  }}</span>
                  <span class="routeTime" style="padding-bottom:10px" v-if="i.actual_depart_time == '' &&
                      trackInfo.actual_arrive_time == ''
                      ">{{ i.plan_depart_time }}</span>
                </div>
              </div>
            </div>
            <div class="routeItem" v-if="trackInfo.arrive_port_name_cn">
              <div class="routeItemHeader">
                <div class="iconWrap">
                  <div v-if="dataindex < 7">
                    <img src="../../assets/img/jiangluo2.png" alt="" />
                  </div>
                  <div v-if="dataindex >= 7">
                    <img src="../../assets/img/jiangluo.png" alt="" />
                  </div>
                </div>
                <label>到达机场：</label>
                <span>{{ trackInfo.arrive_port_name_cn }}</span>
              </div>
              <div :class="dataindex >= 7 ? 'routeDetail' : 'routeDetails'
                ">
                <div class="leftWrap">
                  <span class="routeNo">{{
                    trackInfo.transfer_voyage_name || trackInfo.voyage_name
                  }}</span>
                  <span class="routeTime" v-if="dataindex < 7">{{
                    plan_arriveTime
                  }}</span>
                </div>

                <div class="rightWrap">
                  <div class="timeLine">
                    <div :class="`tlItem ${dataindex >= 7 && 'active'}`">
                      <span>到达时间：{{ trackInfo.actual_arrive_time }}</span>
                    </div>
                    <div :class="`tlItem ${dataindex >= 8 && 'active'}`">
                      <span>提货时间：{{ trackInfo.state_th_time }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="routeItem" v-if="hasEndList">
              <div class="routeItemHeader">
                <div class="iconWrap">
                  <div v-if="dataindex < 7">
                    <img src="../../assets/img/huicar1.png" alt="" />
                  </div>
                  <div v-if="dataindex >= 7">
                    <img src="../../assets/img/car1.png" alt="" />
                  </div>
                </div>
                <div class="my">
                  <div class='my_left'>
                    <label>送货终点：</label>
                    <div class="routeNo">{{
                      trackInfo.give_res.g_truck_name
                    }}</div>
                  </div>

                  <span class="address_text">{{
                    trackInfo.give_res.give_address
                  }}</span>
                </div>
              </div>
              <div v-bind:class="{
                    routeDetail: trackInfo.give_res.give_time !== '',
                    routeDetails: trackInfo.give_res.give_time == '',
                  }">
                <div class="leftWrap">
                  <span class="routeTime" v-if="trackInfo.give_res.coll_time == ''">{{
                    trackInfo.give_res.expect_coll_time
                  }}</span>
                </div>
                <div class="rightWrap">
                  <div class="timeLine">
                    <div class="tlItem active">
                      <span>{{
                        trackInfo.give_res.coll_time ? "已揽收" : "待揽收"
                      }}</span>
                    </div>

                    <div :class="`tlItem ${trackInfo.give_res.coll_time && 'active'
                      }`">
                      <div>
                        <span>揽收时间：{{ trackInfo.give_res.coll_time }}</span>
                      </div>
                    </div>

                    <div :class="['tlItem', trackInfo.give_res.coll_time != '' ? 'active' : '']">
                      <div v-for="(item, index) in trackInfo.give_res.give_data" :key="index">
                        <span>运输卡车：{{ item.give_truck_name }}</span>
                        <span class="text-number">[{{ item.volume }}M³<sup></sup> {{ item.weight }}KG
                          {{ item.number }}箱]</span>
                      </div>
                    </div>

                    <div :class="`tlItem ${trackInfo.give_res.give_time && 'active'
                      }`">
                      <span>送达时间：{{ trackInfo.give_res.give_time }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- 更换请求方式   更换请求数据字段 -->
<script>
import * as turf from '@turf/turf'
import Draw_Map from '../draw_map/draw_map.vue'
import { STATUS_LIST } from '../../assets/js/constant.js'
export default {
  components: {
    Draw_Map
  },
  data() {
    return {
      xuanze: '',
      statusList: STATUS_LIST,
      orderNo: '',
      trackInfo: {},
      isEmpty: false,
      sty: '1',
      rarry: '',
      dataindex: '',
      transform_list: [],
      plan_arriveTime: '', // 预计到达时间
      plan_departTime: '', // 预计离开时间1
      order_type: '',
      order_number: '',
      create_service: '',
      name: '',
      value: '',
      url: '../../../static/img/',
      show: true,
      openid: '',
      is_subscribe: 1,
      width: ''

    }
  },
  beforeCreate() { },
  created() {
    this.query()
    if (this.xuanze == true) {
    }
    if (!this.orderNo) {
      this.isEmpty = true
    }
  },
  computed: {
    StatusTime() {
      return (status) => {
        switch (status) {
          case '已订舱':
            return this.trackInfo.state_dc_time
          case '已发出':
            return this.trackInfo.state_fc_time
          case '已收货':
            return this.trackInfo.state_sh_time
          case '已安检':
            return this.trackInfo.state_aj_time
          case '已入库':
            return this.trackInfo.state_rk_time
          case '已组板':
            return this.trackInfo.state_zb_time
          case '已起飞':
            return this.trackInfo.state_qf_time
          case '已落地':
            return this.trackInfo.state_ld_time
          case '已完成':
            return this.trackInfo.state_wc_time
          case '已提货':
            return this.trackInfo.state_th_time
          default:
            return ''
        }
      }
    },

    hasEndList() {
      return this.trackInfo.give_res.give_address
    },
    hasStartList() {
      return this.trackInfo.coll_res.coll_address
    },
    // 起飞机场图标判断
    takeoff_icon() {
      var flag =
        this.trackInfo.state_sh_time == '' &&
        this.trackInfo.state_aj_time == '' &&
        this.trackInfo.state_rk_time == '' &&
        this.trackInfo.state_zb_time == '' &&
        this.trackInfo.state_qf_time == ''
      var takeoff_index = 0
      if (flag) {
        takeoff_index = 1
      }
      return takeoff_index
    },
    // 起飞机场图标判断1
    tackoff_wire() {
      return (
        this.trackInfo.state_qf_time == '' &&
        this.trackInfo.state !== '已起飞' &&
        this.trackInfo.state !== '已落地' &&
        this.trackInfo.state !== '已提货'
      )
    },
    noHeader() {
      this.width = document.documentElement.clientWidth
      if (
        /Android|webOS|iPhone|iPod|BlackBerry|iPad/i.test(navigator.userAgent)
      ) {
        this.xuanze = true
        document.title = this.orderNo
      } else {
        this.xuanze = false
      }

      return (
        !(this.trackInfo.coll_res && this.trackInfo.coll_res.c_truck_name) &&
        !(this.trackInfo.give_res && this.trackInfo.give_res.g_truck_name)
      )
    }
  },
  methods: {
    switchChange() {
      let data = {
        order_id: this.trackInfo.order_id,
        open_id: this.openid,
        is_subscribe: 1
      }
      if (this.value) {
        data.is_subscribe = 1
      } else {
        data.is_subscribe = 0
      }

      this.$source.post('/subscribe', data).then(res => {
        if (res.data.message == 200) {
          this.$message({
            type: 'success',
            message: '已成功订阅'
          })
        } else if (res.data.message == 201) {
          this.$message({
            type: 'success',
            message: '已取消订阅'
          })
        }
      })
    },
    copy() {
      var input = document.createElement('input') // 创建input对象
      input.value = this.order_number // 设置复制内容
      document.body.appendChild(input) // 添加临时实例
      input.select() // 选择实例内容
      document.execCommand('Copy') // 执行复制
      document.body.removeChild(input) // 删除临时实例1
      this.$message({
        type: 'success',
        message: '复制成功'
      })
    },
    dian() {
      this.show = !this.show
    },
    showList() {
      this.show = false
    },
    query() {
      var order_no = this.$route.query.order_no
      this.openid = this.$route.query.openid

      let data = { order_no: order_no }
      //  data = JSON.stringify(data)
      this.$source.post('/v1/flight_order/detail/track', data).then(
        (res) => {
          console.log(res, 777)
          // 获取运单类型，看是卡运还是空运或者海运
          this.order_type = res.data.data.type
          this.order_number = res.data.data.order_no
          this.create_service = res.data.data.create_service
          this.name = res.data.data.name
          this.value = res.data.data.is_subscribe
          this.trackInfo = res.data.data || {}

          if (this.trackInfo.route_list.length > 0) {
            this.plan_departTime =
              this.trackInfo.route_list[0].plan_depart_time
            this.plan_arriveTime =
              this.trackInfo.route_list[
                this.trackInfo.route_list.length - 1
              ].plan_arrive_time
          }

          // 處理数据获取中转站信息
          for (let i = 0; i < this.trackInfo.route_list.length; i++) {
            if (i + 1 < this.trackInfo.route_list.length) {
              if (
                this.trackInfo.route_list[i].arrive_port_three_no ==
                this.trackInfo.route_list[i + 1].depart_port_three_no
              ) {
                var data = {
                  arrive_port_latitude:
                    this.trackInfo.route_list[i].arrive_port_latitude,
                  arrive_port_longitude:
                    this.trackInfo.route_list[i].arrive_port_longitude,
                  arrive_port_name_cn:
                    this.trackInfo.route_list[i].arrive_port_name_cn,
                  arrive_port_three_no:
                    this.trackInfo.route_list[i].arrive_port_three_no,
                  arrive_port_time_zone:
                    this.trackInfo.route_list[i].arrive_port_time_zone,
                  actual_arrive_time:
                    this.trackInfo.route_list[i].actual_arrive_time,
                  actual_depart_time:
                    this.trackInfo.route_list[i + 1].actual_depart_time,
                  plan_arrive_time:
                    this.trackInfo.route_list[i].plan_arrive_time,
                  plan_depart_time:
                    this.trackInfo.route_list[i + 1].plan_depart_time
                }
                this.transform_list.push(data)
              }
            }
          }

          this.dataindexs()
        },
        (err) => { }
      )
    },

    dataindexs() {
      if (
        this.trackInfo.state == '已订舱' ||
        this.trackInfo.state_dc_time !== ''
      ) {
        // 已订舱时间
        this.dataindex = 0
      }
      if (
        this.trackInfo.state == '已发出' ||
        this.trackInfo.state_fc_time !== ''
      ) {
        // 已发出时间
        this.dataindex = 1
      }
      if (
        this.trackInfo.state == '已收货' ||
        this.trackInfo.state_sh_time !== ''
      ) {
        // 已收货时间
        this.dataindex = 2
      }
      if (
        this.trackInfo.state == '已安检' ||
        this.trackInfo.state_aj_time !== ''
      ) {
        // 已安检时间
        this.dataindex = 3
      }
      if (
        this.trackInfo.state == '已入库' ||
        this.trackInfo.state_rk_time !== ''
      ) {
        // 已入库时间
        this.dataindex = 4
      }
      if (
        this.trackInfo.state == '已组板' ||
        this.trackInfo.state_zb_time !== ''
      ) {
        // 已组板时间
        this.dataindex = 5
      }
      if (
        this.trackInfo.state == '已起飞' ||
        this.trackInfo.state_qf_time !== ''
      ) {
        // 已发货时间
        this.dataindex = 6
      }
      if (
        this.trackInfo.state == '已落地' ||
        this.trackInfo.state_ld_time !== ''
      ) {
        // 已落地时间
        this.dataindex = 7
      }
      if (
        this.trackInfo.state == '已提货' ||
        this.trackInfo.state_wc_time !== ''
      ) {
        // 待结算时间
        this.dataindex = 8
      }
      if (
        this.trackInfo.state == '已完成' ||
        this.trackInfo.state_th_time !== ''
      ) {
        // 已完成时间
        this.dataindex = 9
      }
    },

    getPath() {
      console.log(1111)
    }
  },
  // 监听路由变化
  watch: {
    $route: 'getPath'
  }
}
</script>
<style lang="less">
.my_left {}

.my {
  display: flex;
}

.text-number {
  padding-left: 65px;
}

@import url("../../assets/css/map.less");

.address_text {
  display: inline-block;
  width: 300px;
  text-align: left;
  word-break: break-all;
  padding-top: 3px;
  padding-left: 5px;
}

.fenpi {
  width: 0.416667rem;
  height: 0.125rem;
  text-align: center;
  border-radius: 0.026042rem;
  line-height: 0.125rem;
  margin-bottom: 0.026042rem;
  font-size: 0.072917rem;
  color: #fff;
  font-size: 12px;
}

.zhanwei {
  width: 80px;
  height: 40px;
}

.trackHeader .title {
  height: 20px;
  width: 150px;
  display: inline-block;
}

.mapboxgl-popup /deep/ .mapboxgl-popup-content {
  position: relative;
  background: transparent !important;
  border-radius: 3px;
  box-shadow: none !important;
  padding: 10px 10px 15px;
  pointer-events: auto;
  border: 0;
  padding: 6px;
}

.transform_time {
  width: 60px;
  height: 15px;
  border-radius: 10px;
  color: rgb(133, 164, 182);
  position: absolute;
  right: 50%;
  margin-right: -20px;
  margin-top: 5px;
}

.fortext::before {
  content: attr(data-name);
  display: block;
  position: absolute;
  font-size: 12px;
  left: -100px;
  top: 15px;
  color: #a2a2a2;
  width: 80px;
  text-align: center;

}

.my .routeNo {
  width: 80px;
  height: 24px;
  text-align: center;
  background-color: #e4e7ed;
  border-radius: 5px;
  line-height: 24px;
  margin-bottom: 5px;
  font-size: 14px;
  margin-top: 5px;
}

.head_car {
  width: 100%;
  height: 6vh;
  background: #646E7A;
  line-height: 6vh;
  color: #fff;
  font-size: 14px;
  text-align: left;

  position: relative;
}

.server {
  display: inline-block;
  padding-left: 25px;
}

.car_info {
  width: 344px;
  height: 127px;
  position: absolute;
  z-index: 99;
  left: 50%;
  top: 30px;
  margin-left: -172px;
  border-radius: 10px;
  overflow: hidden;
}

.info_top {

  width: 100%;
  height: 36px;
}

.top_left {
  width: 249px;
  height: 36px;
  background: #133F77;
  border-radius: 0 47px 0 0;
  position: absolute;
  left: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  text-indent: 0;
  font-size: 16px;

}

.top_left span {
  // margin-right: 20px;
}

.top_left img {
  width: 18px;
  height: 18px;
}

.top_right {
  width: 209px;
  height: 36px;
  background: #E5A545;
  position: absolute;
  right: 0;
  text-align: right;
  padding-right: 20px;
}

.info_bottom {
  width: 100%;
  display: flex;
}

.bottom_left {
  width: 134px;
  height: 90px;
  background: #FAFAFA;
  border-radius: 0 0 0 10px;
  z-index: 2;
}

.bottom_right {
  width: 216px;
  height: 90px;
  background: #F4F2F2;
  display: flex;
  justify-content: space-around;
  border-radius: 0 0 10px 0;
  z-index: 2;
}

.plan_time {
  width: 85px;
  height: 17px;
  margin: auto;
  background: #F91E6D;
  border-radius: 18px 12px 12px 0px;
  margin-top: 10px;
  text-align: center;
  color: #fff;
  line-height: 17px;
  font-family: 'Inter';
  font-size: 10px;
}

.state {
  font-family: 'Inter';
  font-size: 20px;
  color: #000000;
  text-align: center;
  width: 100%;
  height: 30px;
  line-height: 30px;
}

.time {
  width: 134px;
  height: 17px;
  font-family: 'Inter';
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: #DADADA;
  margin-top: 7px;
}

.three {
  display: block;
  font-family: 'Inter';
  font-weight: 400;
  font-size: 20px;
  text-align: center;
  color: #A09A9A;
  height: 24px;
  line-height: 24px;
  width: 60px;
  text-align: center;
  margin-top: 15px;
}

.address {
  display: block;
  font-family: 'Inter';
  font-size: 16px;
  text-align: center;
  color: #A09A9A;
  height: 19px;
  line-height: 19px;
  width: 60px;
  text-align: center;
  margin-top: 11px;
}

.d1 {
  width: 100px;
  height: 100%;
}

.gang {
  width: 40px;
  height: 16px;
  margin-top: 30px;
}

.scroll {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 50%;
  border-radius: 10px 10px 0 0;
  background: #FAFAFA;
  z-index: 999;
  overflow-y: auto;
  scrollbar-width: none
}

.scroll2 {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 5%;
  border-radius: 10px 10px 0 0;
  background: #FAFAFA;
  z-index: 999;
  overflow-y: auto;
  scrollbar-width: none
}

::-webkit-scrollbar {
  display: none;
}

.scroll_head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 9px;
}

.just_flex {
  display: flex;
}

.push {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  margin-left: 80px;
  margin-top: 14px;
  white-space: nowrap;

}

.details {
  margin-left: 26px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #000000;
  margin-top: 13px;
  white-space: nowrap;
}

.switch {
  margin-right: 40px;
  margin-top: 13px;
  margin-left: 10px;

}

.el-switch.is-checked .el-switch__core {
  transform: calc(0.6) !important;
}

.step_content {
  width: 100%;
  margin-left: 26px;
  text-align: left;
}

.el-step.is-vertical .el-step__title {
  text-align: left;
}

.dot {
  width: 300px;
  padding-bottom: 10px;
  text-align: left;
}

.el-step__description.is-finish {
  color: #000000 !important;
}

.el-step__description.is-process,
.el-step__description.is-wait {
  color: #ACA9A9 !important;
}

.el-step__title.is-process,
.el-step__title.is-wait {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  color: #01020E !important;
}

.el-step__title.is-finish {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  color: #1A4E83 !important;
}

.fenpi {
  padding-left: 5px;
  color: #0F5044;
  white-space: nowrap;
}

.el-step.is-vertical .el-step__line {
  top: 3px !important;
  bottom: -1px !important;
  left: 8px;
}

.icon {
  width: 100%;
  height: 100%;
}

.step_image {
  width: 18px;
  height: 18px;
}

.el-step__icon.is-text {
  width: 18px;
  height: 18px;
  margin-top: 4px;
  border: none;
}

.stateTag {
  display: inline-block;
  border-radius: 6px 6px 6px 0px;
  background: var(--linear, linear-gradient(313deg, #E85F69 7.64%, #F57A6B 100%));
  width: 46px;
  height: 20px;
  padding: 2px 3px 0 3px;
  color: #fff;
  margin-top: -16px;
  margin-left: -50px;
}
.stateTag.flying {
  background: linear-gradient(313deg, #3BA173 0%, #63CB9C 100%);
}
.stateTag.finish {
  background: linear-gradient(313deg, #194BA8 7.64%, #5483DA 100%);
}
.noticeTime {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #194BA8;
  font-size: 14px;
  margin: -30px 0 30px 0;
}
.noticeTime img {
  width: 16px;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/public/map.vue